var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-base-rail',{attrs:{"label":"autores","variant":"authors"}},_vm._l((_vm.items),function(author){return _c('home-author-card',{key:author.id,attrs:{"author":author}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }